module.exports = __webpack_public_path__ + "static/img/bg2.5c481ee7.png";